import React from "react";
import { Helmet } from "react-helmet-async";
import SEO from "../../components/SEO";
import Navbar from "../../components/Navbar";
import Hero from "./component/hero/Hero";
import About from "./component/about/About";
import Services from "./component/services/Services";
import Products from "./component/products/Products";
import Testimonials from "./component/testimonials/Testimonials";
import Footer from "../../components/Footer";
import { structuredData } from "../../data/structuredData";

function Home() {
  return (
    <>
      <SEO
        description="RaStegHub is a tech innovation hub in Nairobi building software, SaaS products, and digital solutions for businesses across Africa."
        url="/"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <div>
        <Navbar />
        <Hero />
        <About />
        <Services />
        <Products />
        <Testimonials />
        <Footer />
      </div>
    </>
  );
}

export default Home;